import { Button } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import useText from "constants/text";
import React from "react";
import { IFooter } from "../data/types";
import { useFooterStyles } from "../style";

const Footer = ({ handleCancelCreation, handleCreation, isEdit, isLoading }: IFooter) => {
  const classes = useFooterStyles();
  const { text } = useText();
  return (
    <div className={classes.container}>
      {isLoading ? (
        <>
          <Skeleton className={classes.skeleton} />
          <Skeleton className={classes.skeleton} />
        </>
      ) : (
        <>
          <Button className={classes.cancelButton} onClick={handleCancelCreation} color="primary" variant="outlined">
            {text.all.cancel}
          </Button>
          <Button className={classes.confirmButton} onClick={handleCreation} color="primary" variant="outlined">
            {isEdit ? text.all.edit : text.all.create}
          </Button>
        </>
      )}
    </div>
  );
};

export default Footer;
